import React, { Component } from "react";

/**
 * ErrorBoundary — catches render errors so a crash in one route
 * doesn't blank the entire app.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 320,
          padding: "48px 24px",
          textAlign: "center",
        }}>
          <div style={{
            fontSize: 40,
            marginBottom: 16,
            color: "#3daa4e",
            fontWeight: 600,
            letterSpacing: "-1px",
          }}>
            Oops
          </div>
          <p style={{ fontSize: 14, color: "#595959", maxWidth: 420, marginBottom: 24, lineHeight: 1.6 }}>
            Something went wrong loading this page.
          </p>
          <details style={{ marginBottom: 24, textAlign: "left", maxWidth: 500 }}>
            <summary style={{ cursor: "pointer", fontSize: 12, color: "#8fa096", marginBottom: 8 }}>
              Error details
            </summary>
            <pre style={{
              fontSize: 11,
              background: "#f4f9f4",
              padding: "12px 16px",
              borderRadius: 8,
              overflow: "auto",
              color: "#d32f2f",
              maxHeight: 200,
            }}>
              {this.state.error?.message || String(this.state.error)}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#3daa4e",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "10px 24px",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
